module.exports = __webpack_public_path__ + "img/system-3.79d5422.png";